import { render, staticRenderFns } from "./DesktopNotSupported.vue?vue&type=template&id=558d46fe&scoped=true"
import script from "./DesktopNotSupported.vue?vue&type=script&lang=js"
export * from "./DesktopNotSupported.vue?vue&type=script&lang=js"
import style0 from "./DesktopNotSupported.vue?vue&type=style&index=0&id=558d46fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d46fe",
  null
  
)

export default component.exports